import React, { useEffect, useRef, useState } from 'react';
import styles from './FlipDigit.module.scss';

interface FlipDigitProps {
  value: string;
}

export const FlipDigit: React.FC<FlipDigitProps> = ({ value }) => {
  const [currentValue, setCurrentValue] = useState(value);
  const [isFlipping, setIsFlipping] = useState(false);
  const prevValueRef = useRef(value);

  useEffect(() => {
    if (value !== prevValueRef.current) {
      setIsFlipping(true);

      const mid = setTimeout(() => {
        setCurrentValue(value);
      }, 300);

      const end = setTimeout(() => {
        setIsFlipping(false);
      }, 600);

      prevValueRef.current = value;

      return () => {
        clearTimeout(mid);
        clearTimeout(end);
      };
    }
  }, [value]);

  return (
    <div className={styles.flipContainer}>
      <div className={styles.mainCard}>{currentValue}</div>

      {isFlipping && (
        <>
          <div className={`${styles.flipHalf} ${styles.flipTop}`}>
            <div className={styles.flipContent}>{prevValueRef.current}</div>
          </div>
          <div className={`${styles.flipHalf} ${styles.flipBottom}`}>
            <div className={styles.flipContent}>{value}</div>
          </div>
        </>
      )}

      <div className={styles.centerDivider}></div>
    </div>
  );
};
